// extracted by mini-css-extract-plugin
module.exports = {"ul":"TagsGray_ul__1xTyE","skin_colorBox":"TagsGray_skin_colorBox__2Dg9m","tag_linkbox":"TagsGray_tag_linkbox__2hwuE","industry_linkbox":"TagsGray_industry_linkbox__1Y7Pz"};